export default "__VITE_ASSET__02bedbeb__"